/**
 * Partagé entre le web (ré-export `pages/housekeeping/helpers/planningDays.ts`) et le mobile.
 *
 * Jours de planning au format `YYYY-MM-DD`, calculés en UTC : un jour calendaire de l'hôtel
 * (donné par le serveur) ne doit jamais glisser avec le fuseau du navigateur ni le changement d'heure.
 */

const DAY_MS = 24 * 60 * 60 * 1000;
const ISO_DAY = /^\d{4}-\d{2}-\d{2}$/;

const toUtc = (day: string): number => Date.parse(`${day}T00:00:00Z`);

export function addDays(day: string, count: number): string {
    return new Date(toUtc(day) + count * DAY_MS).toISOString().slice(0, 10);
}

/** Jours sélectionnables, de `today` à `maxDate` inclus ; au minimum `today`. */
export function planningDays(today: string, maxDate: string): string[] {
    const days = [today];
    if (!ISO_DAY.test(today) || !ISO_DAY.test(maxDate)) return days;
    const count = Math.round((toUtc(maxDate) - toUtc(today)) / DAY_MS);
    for (let i = 1; i <= count; i++) days.push(addDays(today, i));
    return days;
}

/** Libellé court d'un jour (ex. « dim. 25 oct. »), sans conversion de fuseau. */
export function formatPlanningDay(day: string, locale?: string): string {
    return new Date(toUtc(day)).toLocaleDateString(locale, {weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC'});
}
